let data = [
  {
    slug: 'learning-outcomes',
    title: `Guide to Writing Learning Outcomes`,
    content: `<p>Learining outcomes help people determine what they will get out of a learning experience and give them a method for evaluating if they've achieved the goals they set out towards when they started learning.</p><p>It's important to differentiate if your learning goals are simple (like just being able to recall something you were told), or complex (like being able to create your own new thing based on what you learned). Knowing what you expect learners to do can help you shape the learning experience to fit their needs. </p>

      <p>Aim for a reasonable number of learning outcomes. Usually 3-5 work well. Add too many and learners will skim over them without taking them in. Try to write in the plainest possible language so that everyone is clear on what success will look like. And try to avoid vague verbs like “understand” or “learn.” Those are hard to measure.</p>
      <h3>Determining a Successful End State</h3>
      <p>When writing outcomes, think about what you expect someone would be able to do if they completed the learning experience successfully. </p>
      <i>For example:</i>
      <p>After completing this lesson, you will be able to...</p>
        <ul>
        <li>Identify the components of...</li>
        <li>Analyze data using...</li>
        <li>Design a strategy for...</li></ul>
        
        <h3>Picking the right verb</h3>
        <p>Choose a verb that matches the desired level of knowledge or skill for each outcome. Verbs should indicate specific, measurable, and observable behaviors. You may have to modify your outcomes as you really consider what level of complexity you want learners to end on.</p><p>This table of verbs starts at least complex with "Remember" on the left and ends at most complex on the right with "Create."</p>
        
       <table>
       <thead>
       <tr>
       <td>Remember</td>
       <td>Comprehend</td>
       <td>Apply</td>
       <td>Analyze</td>
       <td>Evaluate</td>
       <td>Create</td>
       </tr>
       </thead>
       <tbody>
         <td>  <p>Define</p>
        <p>Recall</p>
        <p>Recognize</p></td>
       <td>  <p>Explain</p>
        <p>Discuss</p>
        <p>Recognize</p>
        <p>Identify</p></td>
       <td> <p>Demonstrate</p>
        <p>Execute</p>
        <p>Implement</p>
        <p>Practice</p>
        <p>Use</p></td>
       <td> <p>Debate</p>
        <p>Describe</p>
        <p>Examine</p>
        <p>Review</p>
        <p>Summarize</p></td>
       <td>  <p>Assess</p>
        <p>Compare</p>
        <p>Determine</p></td>
       <td>  <p>Compose</p>
        <p>Design</p>
        <p>Develop</p>
        <p>Prepare</p>
        <p>Produce</p></td>
       </tbody>
        </table>
        <p>Got it? Great! Now, get to writing!</p>
        `
  }
]

export default data;